var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3673_16442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3765 45.263L0.722656 0.583984L44.359 0.673769L40.4954 45.263L22.7055 50.4169L4.3765 45.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7051 46.1008V4.83789L40.6748 4.89775L37.4704 41.8154L22.7051 46.1008Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7811 9.73828H16.0304V37.2018L12.3354 36.4976V32.8006L7.93652 32.0964V40.3707L20.7811 43.7156V9.73828ZM24.3449 9.73828H37.4966L36.6169 15.0021H29.3655V23.6401H36.6169L35.7371 41.0749L24.3449 43.7156V38.2581L32.0421 35.6174L32.4866 28.3994L24.3449 29.5789V9.73828Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_16442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.6364,
    height: 50,
    fill: "white",
    transform: "translate(0.722656 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.d6431c5bb50b2f9554fc354382e73ee1.svg";
export { ForwardRef as ReactComponent };